import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function BonusesSection() {
  return <section className="w-full bg-slate-100 px-4 py-12 sm:px-5 sm:py-16" data-id="element-17" data-mp="gwx3kxxwuxbm">
      <div className="mx-auto max-w-[1000px]" data-id="element-18" data-mp="vt62tzhsxao1">
        <h2 className="text-balance text-center text-[clamp(1.6rem,4.5vw,2.6rem)] font-black uppercase leading-none tracking-tight text-slate-950" data-id="element-19" data-mp="vqtdv2dmm01h">
          5 premium bonuses <span className="text-orange-700" data-id="element-20" data-mp="14s9n36spfw44">included</span>
        </h2>
        <p className="mx-auto mt-4 max-w-[600px] text-center text-[1rem] leading-relaxed text-slate-700 sm:text-[1.05rem]" data-id="element-21" data-mp="zv15b7bgxu3e">
          You'll also receive 5 premium bonuses designed to help you plan,
          teach, review, assess, and organize Anatomy & Physiology more
          efficiently.
        </p>

        <ol className="mt-8 grid gap-4 md:grid-cols-2" data-id="element-22" data-mp="1njal9sm03nmm">
          {bonuses.map((bonus, index) => <li key={bonus.label} className={`flex flex-col rounded-xl border-[3px] border-slate-950 bg-white p-5 sm:p-6 ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-23" data-mp="1jj9vxcxd5s0s" data-mpi={index}>
              <span className="inline-flex w-fit items-center gap-2 rounded-md bg-orange-500 px-3 py-1.5 text-[0.85rem] font-black uppercase tracking-[0.14em] text-slate-950" data-id="element-24" data-mp="3tu013vh2dumw">
                <GiftIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-25" data-mp="7ma469uffxpa" />
                {bonus.label}
              </span>
              <h3 className="mt-3 text-[1.25rem] font-black uppercase leading-[1.05] tracking-tight text-slate-950 sm:text-[1.35rem]" data-id="element-26" data-mp="chz6um1qtupt">
                {bonus.title}
              </h3>
              <p className="mt-2 text-[1rem] leading-relaxed text-slate-700" data-id="element-27" data-mp="lcvn1yjvs7n6">
                {bonus.description}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}